import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { CmsContent, CmsTaxonomy } from '@fcom/core-api';

@Component({
  selector: 'fin-editorial-category',
  templateUrl: './editorial-category.component.html',
  styleUrls: ['./editorial-category.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditorialCategoryComponent {
  @Input()
  editorialCategory: CmsContent;

  isShowAllLink(article: CmsContent): boolean {
    return article.subjectTaxonomyTags.includes(CmsTaxonomy.ARROW_LINK);
  }
}
